import NotificationPreferences from './notification-preferences'
export default NotificationPreferences
